module.exports = __webpack_public_path__ + "img/1586313735.3982cd7f.jpg";